import React, { Component } from "react";

import "./Contact.css";
import Input from "../../components/UI/Input/Input";
import axios from "axios";
import Modal from "../../components/UI/Modal/Modal";
import Aux from "../../hoc/Aux/Aux";
import MyMap from "../Map/Map";

class Contact extends Component {
  state = {
    registerForm: {
      name: {
        elementType: "input",
        inputClasses: "form-control",
        iIcon: "fa fa-user",
        elementConfig: {
          type: "text",
          placeholder: "Imię i Nazwisko"
        },
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      },
      email: {
        elementType: "input",
        inputClasses: "form-control",
        iIcon: "fa fa-envelope",
        elementConfig: {
          type: "email",
          placeholder: "Adres e-mail"
        },
        value: "",
        validation: {
          required: true,
          isEmail: true
        },
        valid: false,
        touched: false
      },
      question: {
        elementType: "textarea",
        inputClasses: "form-control",
        iIcon: "fa fa-pencil",
        elementConfig: {
          type: "text",
          placeholder: "Treść"
        },
        value: "",
        validation: {
          required: true
        },
        valid: false,
        touched: false
      }
    },
    formIsValid: false,
    sendMailConfirmed: false
  };
  registerHandler = event => {
    event.preventDefault();
    const formData = {};
    for (let formElementIdentifier in this.state.registerForm) {
      formData[formElementIdentifier] = this.state.registerForm[
        formElementIdentifier
      ].value;
    }

    const clearedFormData = { ...this.state.registerForm };
    for (let formElementIdentifier in clearedFormData) {
      clearedFormData[formElementIdentifier].value = "";
    }

    axios({
      method: "post",
      url: "http://akcentbud.pl:8080/szatnia",
      data: {
        clientName: formData.name,
        clientMail: formData.email,
        text: formData.question
      }
    }).then(res => {
      console.log(res);
      this.setState({
        registerForm: clearedFormData,
        formIsValid: false,
        sendMailConfirmed: true
      });
    });
  };

  checkValidity(value, rules) {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      isValid = value.trim() !== "" && isValid;
    }

    if (rules.isEmail) {
      const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      isValid = pattern.test(value) && isValid;
    }

    return isValid;
  }

  inputChangedHandler = (event, inputIdentifier) => {
    const updatedRegisterForm = {
      ...this.state.registerForm
    };
    const updatedFormElement = {
      ...updatedRegisterForm[inputIdentifier]
    };
    updatedFormElement.value = event.target.value;
    updatedFormElement.valid = this.checkValidity(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updatedRegisterForm[inputIdentifier] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedRegisterForm) {
      formIsValid = updatedRegisterForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({
      registerForm: updatedRegisterForm,
      formIsValid: formIsValid
    });
  };

  mailSendConfirmedHandler = () => {
    this.setState({ sendMailConfirmed: null });
  };

  render() {
    const formElementsArray = [];
    for (let key in this.state.registerForm) {
      formElementsArray.push({
        id: key,
        config: this.state.registerForm[key]
      });
    }
    let form = (
      <form onSubmit={this.registerHandler}>
        {formElementsArray.map(formElement => (
          <Input
            key={formElement.id}
            inputClasses={formElement.config.inputClasses}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldValidate={formElement.config.validation}
            touched={formElement.config.touched}
            changed={event => this.inputChangedHandler(event, formElement.id)}
            icon={formElement.config.iIcon}
          />
        ))}
        <button
          className="btn btn-block btn-lg text-light mb-3"
          disabled={!this.state.formIsValid}
        >
          WYŚLIJ
        </button>
      </form>
    );
    return (
      <Aux>
        <Modal
          show={this.state.sendMailConfirmed}
          modalClosed={this.mailSendConfirmedHandler}
        >
          {this.state.sendMailConfirmed
            ? "Mail został pomyślnie wysłany."
            : null}
        </Modal>
        <section id="contact" className="py-3">
          <div className="container p-5">
            <div className="row">
              <div className="col my-3">
                <h3>KONTAKT</h3>
                <p className="lead">
                  Masz jakieś pytania? Skontaktuj się z nami za pomocą
                  poniższego formularza.
                </p>
                <MyMap
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBlfW9m-0VAfP6eRMihWRx_u6u0c627DTE&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `400px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8">{form}</div>
              <div className="col-lg-4">
                <h4>Adres</h4>
                <p className="text-muted">
                  Akcentbud Grzegorz Dworak
                  <br />Ul. Generała Stefana Grota -Roweckiego 11
                  <br />33-100 Tarnów
                  <br />NIP: 873 121 39 15
                  <br />Telefon: +48 693 44 98 96
                  <br />Mail: e-szatnia@akcentbud.pl
                </p>
              </div>
            </div>
          </div>
        </section>
      </Aux>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/Contact/Contact.js